<template>
  <span>{{ group && stripPrefix(group.name) }}</span>
</template>

<script>
import last from "lodash/last";

export function stripPrefix(name) {
  if (!name) {
    return "";
  }
  return last(name.split("::"));
}

export default {
  name: "group-name",
  props: {
    group: {
      type: Object,
      default: null,
    }
  },
  methods: {
    stripPrefix,
  }
};
</script>

<style scoped>
</style>